import { Directive, ElementRef } from '@angular/core';

type InputLikeElement = HTMLInputElement & HTMLTextAreaElement;

/**
 *  In angular, it's impossible to pass props downstream like in react
 *  (https://stackoverflow.com/q/47297089/8160318) so any shared props have to be
 *  declared either as @Inputs or standard, static attributes.
 *
 *  The most maintainable way to declare shared props is via a directive in which
 *  said props are declared once.
 */
@Directive({
    selector: '[appGxInput]',
    standalone: true,
})
export class GxInputDirective {

  constructor(el: ElementRef) {
    const element = (el.nativeElement as InputLikeElement);

    element.autocomplete = 'off';  // introduced in BLS-2860

    // more shared props to follow
  }

}
